import React from "react";
import { Rail } from "web/react/components/rail/rail";
import { RailCardSerializer } from "web/types/serializers";
import { RelatedRailCard } from "./related-rail-card";

interface RelatedRailProps {
    title?: string;
    candidates: RailCardSerializer[];
    isFeedRedesign?: boolean;
    analyticsLabel: string;
}

export function RelatedRail({
    title,
    candidates,
    analyticsLabel,
}: RelatedRailProps): React.ReactElement {
    return (
        <Rail title={title} wrapLimit={6} analyticsLabel={analyticsLabel} shouldWrap>
            {candidates.map((candidate) => {
                return <RelatedRailCard key={candidate.url} candidate={candidate} />;
            })}
        </Rail>
    );
}
